module.exports = __webpack_public_path__ + "static/media/code.9598016c.svg";